import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames'; // import Input from 'ui/components/input'

import PopupDialog from 'ui/components/popup-dialog';
import i18n from 'i18next';
import InputAutoComplete from './ui/input-auto-complete';
import Input from './ui/input';
import ah from '../utils/ajax-helper';
import ModalDialog from './ui/modal-dialog';
import Form from './ui/form';

var log = require('loglevel').getLogger('reset-password');

var t = i18n.getFixedT(null, 'user');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var inlineInitialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = inlineInitialState.envCfg;

var ResetPassword = /*#__PURE__*/function (_React$Component) {
  _inherits(ResetPassword, _React$Component);

  var _super = _createSuper(ResetPassword);

  function ResetPassword(props) {
    var _this;

    _classCallCheck(this, ResetPassword);

    _this = _super.call(this, props);
    _this.state = _objectSpread(_objectSpread({}, props), {}, {
      param0: '',
      param1: '',
      param2: '',
      systemMinPasswordLength: -1,
      formValid: false
    });

    _this.getSystemMinPasswordLength();

    return _this;
  }

  _createClass(ResetPassword, [{
    key: "getSystemMinPasswordLength",
    value: function getSystemMinPasswordLength() {
      var _this2 = this;

      ah.get("".concat(cfg.contextRoot, "/system-config/system.min.password.length")).then(function (result) {
        if (result.code != -1) {
          _this2.setState({
            systemMinPasswordLength: result.data.value.value
          });
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFormValidateion();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state = this.state,
          param0 = _this$state.param0,
          param1 = _this$state.param1,
          param2 = _this$state.param2;
      if (!_.isEqual(prevState.param0, param0) || !_.isEqual(prevState.param1, param1) || !_.isEqual(prevState.param2, param2)) this.handleFormValidateion();
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      this.setState({
        param0: value.param0,
        param1: value.param1,
        param2: value.param2
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var onClose = this.props.onClose;
      this.handleError();
      this.setState(initialState);
      onClose();
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this3 = this;

      var userName = this.props.userName;
      var _this$state2 = this.state,
          param0 = _this$state2.param0,
          param1 = _this$state2.param1,
          param2 = _this$state2.param2;
      if (_.isEmpty(param0) || _.isEmpty(param1) || _.isEmpty(param2)) return this.handleError(et('txt-fill-out-required'));
      if (param1 != param2) return this.handleError(t('txt-password-not-match'));
      if (userName == param1) return this.handleError(t('txt-password-equals-user-name'));
      ah.post("".concat(cfg.contextRoot, "/user/credential/edit"), JSON.stringify({
        oriPd: param0,
        newPd: param1
      }), null, true).then(function (result) {
        if (result.code < 0) return _this3.handleError(et(result.messageCode));
        PopupDialog.alert({
          display: t('txt-password-reset-succeed'),
          confirmText: gt('global.lbl-answer-ok'),
          act: function act(confirmed) {
            return ah.get("".concat(cfg.contextRoot, "/logout"));
          }
        });
        return _this3.handleClose();
      }).catch(function (err) {
        return _this3.handleError(err.message);
      });
    }
  }, {
    key: "handleError",
    value: function handleError() {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.setState({
        info: err,
        error: err !== ''
      });
    }
  }, {
    key: "handleFormValidateion",
    value: function handleFormValidateion() {
      var _this4 = this;

      window.requestAnimationFrame(function () {
        var formValid = ReactDOM.findDOMNode(_this4.form).getElementsByClassName('invalid').length == 0;
        if (formValid) return _this4.handleError();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          title = _this$props.title,
          userName = _this$props.userName,
          forceReset = _this$props.forceReset;
      var _this$state3 = this.state,
          param0 = _this$state3.param0,
          param1 = _this$state3.param1,
          param2 = _this$state3.param2,
          info = _this$state3.info,
          error = _this$state3.error,
          formValid = _this$state3.formValid,
          systemMinPasswordLength = _this$state3.systemMinPasswordLength;
      var data = {
        id: userName,
        param0: param0,
        param1: param1,
        param2: param2
      };
      var pattern = new RegExp("^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&/=?_.,:;\\-])).{".concat(systemMinPasswordLength, ",}|\\{\\(enc\\)\\}.*$"));
      var actions = {};

      if (!forceReset) {
        _.set(actions, 'cancel', {
          text: gt('global.lbl-answer-cancel'),
          handler: this.handleClose.bind(this)
        });
      }

      _.set(actions, 'confirm', {
        text: gt('global.lbl-answer-ok'),
        className: 'button-success',
        // disabled: !formValid,
        handler: this.handleConfirm.bind(this)
      });

      return /*#__PURE__*/React.createElement(ModalDialog, {
        id: "g-reset-password",
        title: title ? title : t('dlg-reset-password'),
        global: true,
        info: info,
        infoClassName: cx({
          'c-error': error
        }),
        actions: actions,
        closeAction: "cancel"
      }, /*#__PURE__*/React.createElement(Form, {
        id: "g-reset-password-form",
        ref: function ref(_ref) {
          return _this5.form = _ref;
        },
        className: "pure-form-aligned",
        fieldClassName: "pure-control-group",
        fields: {
          param0: {
            label: t('lbl-ori-password'),
            editor: Input,
            props: {
              type: 'password',
              validate: {
                required: true,
                t: function t(code) {
                  return et("txt-".concat(code));
                }
              }
            }
          },
          param1: {
            label: t('lbl-new-password'),
            editor: InputAutoComplete,
            props: {
              type: 'password',
              validate: {
                required: true,
                pattern: pattern,
                t: function t(code) {
                  return et("txt-".concat(code));
                }
              }
            }
          },
          param2: {
            label: t('lbl-re-new-password'),
            editor: Input,
            props: {
              type: 'password',
              required: true,
              validate: {
                t: function t(code) {
                  return et("txt-".concat(code));
                }
              }
            }
          }
        },
        onChange: this.handleChange.bind(this),
        value: data,
        footer: t('txt-password-pattern', {
          length: parseInt(systemMinPasswordLength)
        })
      }));
    }
  }]);

  return ResetPassword;
}(React.Component);

var initialState = {
  param0: '',
  param1: '',
  param2: '',
  info: null,
  error: false
};
var initialFormState = {
  userName: null,
  param0: '',
  param1: '',
  param2: '',
  info: null,
  error: false
};
ResetPassword.defaultProps = {
  title: '',
  userName: null,
  param0: '',
  param1: '',
  param2: ''
};
ResetPassword.propTypes = {
  title: PropTypes.string,
  userName: PropTypes.string,
  onClose: PropTypes.func
};
export default ResetPassword;